import {AppliedDiscount, AppliedDiscountDiscountType} from '@wix/auto_sdk_ecom_current-cart';
import {CouponModel} from '../models/Cart/Coupon.model';
import {ModelContext} from '../../types/app.types';

export const toAppliedCouponCartV1 = (appliedDiscounts: AppliedDiscount[], modelContext: ModelContext) => {
  const appliedCoupon = appliedDiscounts?.find((discount) => discount.coupon);
  const discountType = appliedCoupon?.discountType;
  return appliedCoupon ? CouponModel.fromCartV1(appliedCoupon.coupon, discountType, modelContext) : undefined;
};

export const isFreeShippingCoupon = (coupon?: CouponModel): boolean =>
  coupon?.discountType === AppliedDiscountDiscountType.SHIPPING;
